
import styled from 'styled-components';
import { media } from '../common/common-data';
import { pxToRem } from '../common/utils/ConvertUtils';
import i18n from './i18n/i18n';

export const TitleNormal = styled.div<{
  color?: string;
  fontSize?: string | number;
  lineHeight?: string | number; // ✅ lineHeight prop 추가
}>`
  font-size: ${({ fontSize }) =>
    fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '16px'};
  font-weight: 400;
  line-height: ${({ lineHeight }) =>
    lineHeight ? (typeof lineHeight === 'number' ? `${lineHeight}` : lineHeight) : '1'}; // ✅ 동적 적용
  color: ${({ color }) => color || '#232D42'};
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  white-space: normal;
  word-break: keep-all;
`;

export const TitleLarge = styled(TitleNormal)`
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '33px')}; /* 기본 크기 33px */
`;

export const TitleLargeMedium = styled(TitleLarge)`
  font-weight: 475;
`;

export const TitleSmall = styled(TitleNormal)`
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '13px')}; /* 기본 크기 13px */
`;

export const TitleNormalBold = styled(TitleNormal)`
  font-weight: 700; /* Bold 폰트로 변경 */
`;

export const HeaderNormal = styled.div<{
  color?: string;
  fontSize?: string | number;
  weight?: number | string;
}>`
  font-size: ${({ fontSize }) =>
    fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '80px'};
  font-weight: ${({ weight }) => weight || 700};
  line-height: 1;
  color: ${({ color }) => color || '#000000'};
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  white-space: normal;     /* 🔥 줄바꿈 허용 */
  word-break: keep-all;    /* 🔥 단어 단위로 줄바꿈 (한국어에 좋음) */

  ${media.tablet`
    font-size: 64px;
  `}

  ${media.mobile`
    font-size: 40px;
  `}
`;

export const ParagraphNormal = styled.div<{
  color?: string;
  fontSize?: string | number;
  weight?: number | string; // ✅ transient prop
}>`
  font-size: ${({ fontSize }) =>
    fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : '28px'};
  font-weight: ${({ weight }) => weight || 400};  // ✅ 사용
  line-height: 1.5;
  color: ${({ color }) => color || '#000000'};
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  white-space: normal;
  word-break: keep-all;

  ${media.tablet`
    font-size: 26px;
  `}

  ${media.mobile`
    font-size: 14px;
  `}
`;

export const Body1 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-weight: 400;
  font-size: ${pxToRem(32)};
  line-height: ${pxToRem(48)};
  letter-spacing: 0px;
  color: ${({ theme }) => theme.colors.DefaultTextColor};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 14px;
    line-height:22px;
  `}
`;

export const Body2 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-weight: 700;
  font-size: ${pxToRem(28)};
  line-height: ${pxToRem(40)};
  letter-spacing: 0px;
  color: black;

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 13px;
    line-height:18px;
  `}
`;

export const Body3 = styled.div`
  font-size: ${pxToRem(30)};
  font-weight: 700;
  line-height: ${pxToRem(40)};
  letter-spacing: 0px;
  color: #232D42;

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 16px;
    line-height: 22px;
  `}
`;

export const Body4 = styled.div`
  font-size: ${pxToRem(30)};
  font-weight: 700;
  line-height: ${pxToRem(44)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 18px;
    line-height: 27px;
  `}
`;

export const Text1 = styled.div`
  font-size: ${pxToRem(28)};
  font-weight: 400;
  line-height: ${pxToRem(44)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 14px;
    line-height:22px;
    letter-spacing: -0.01em;
  `}
`;

export const Text3 = styled.div`
  font-size: ${pxToRem(22)};
  font-weight: 400;
  line-height: ${pxToRem(36)};
  letter-spacing: 0px;
  color: #232D42;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 13px;
    line-height:22px;
  `}
`;

export const Text4 = styled.div`
  font-size: ${pxToRem(26)};
  font-weight: 400;
  line-height: ${pxToRem(42)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 14px;
    line-height:24px;
    letter-spacing: -0.01em;
  `}
`;

export const Text5 = styled.div`
  font-size: ${pxToRem(22)};
  font-weight: 400;
  line-height: ${pxToRem(42)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;
`;

export const H0 = styled.div`
  font-size: ${pxToRem(150)};
  font-weight: 700;
  line-height: ${pxToRem(150)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 70px;
    line-height: 80px;
  `}
`;

export const H1 = styled.div`
  font-size: ${pxToRem(80)};
  font-weight: 700;
  line-height: ${pxToRem(86)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 26px;
    line-height: 32px;
    letter-spacing: -0.8px;
  `}
`;

export const H2 = styled.div`
  font-size: ${pxToRem(70)};
  font-weight: 700;
  line-height: ${pxToRem(76)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 26px;
    line-height: 34px;
    letter-spacing: -0.5px;
  `}
`;

export const H3 = styled.div`
  font-size: ${pxToRem(60)};
  font-weight: 700;
  line-height: ${pxToRem(90)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 24px;
    line-height: 32px;
  `}
`;

export const H4 = styled.div`
  font-size: ${pxToRem(52)};
  font-weight: 700;
  line-height: ${pxToRem(70)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 20px;
    line-height: 28px;
  `}
`;

export const H5 = styled.div`
  font-size: ${pxToRem(34)};
  font-weight: 700;
  line-height: ${pxToRem(45)};
  letter-spacing: 0px;
  color: #000000;
  white-space: normal;     /* 🔥 줄바꿈 허용 */
  word-break: keep-all;    /* 🔥 단어 단위로 줄바꿈 (한국어에 좋음) */
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 17px;
    line-height: 24px;
  `}
`;

export const H6 = styled.div`
  font-size: ${pxToRem(70)};
  font-weight: 400;
  line-height: ${pxToRem(90)};
  letter-spacing: 0px;
  color: #ffffff;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 26px;
    line-height: 38px;
  `}
`;

export const H7 = styled.div`
  font-size: ${pxToRem(40)};
  font-weight: 700;
  line-height: ${pxToRem(60)};
  letter-spacing: 0px;
  color: #232D42;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 16px;
    line-height: 24px;
  `}
`;

export const H8 = styled.div`
  font-size: ${pxToRem(38)};
  font-weight: 700;
  line-height: ${pxToRem(38)};
  letter-spacing: 0px;
  color: #232D42;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;
`;

export const H9 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-weight: 400;
  font-size: ${pxToRem(30)};
  line-height: 100%;
  letter-spacing: 0px;
  color: #000000;

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 15px;
    line-height: 22px;
  `}
`;

export const H10 = styled.div`
  font-size: ${pxToRem(24)};
  font-weight: 400;
  line-height: ${pxToRem(38)};
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 14px;
    line-height: 22px;
  `}
`;

export const Data1 = styled.div`
  font-size: ${pxToRem(60)};
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0px;
  color: #000000;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 28px;
    line-height: 30px;
  `}
`;

export const Point1 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;
  font-weight: 400;
  font-size: ${pxToRem(28)};
  line-height: ${pxToRem(44)};
  letter-spacing: 0px;
  color: black;

  ${media.mobile`
    font-size: 11px;
    line-height: 14px;
  `}
`;

export const Point2 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-weight: 700;
  font-size: ${pxToRem(24)};
  line-height: ${pxToRem(44)};
  letter-spacing: 0px;
  color: black;

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 14px;
    line-height: 20px;
  `}
`;

export const Point3 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-weight: 400;
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(24)};
  letter-spacing: 0px;
  color: black;

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 10px;
    line-height: 16px;
  `}
`;

export const SubH1 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-weight: 700;
  font-size: ${pxToRem(100)};
  line-height: ${pxToRem(120)};
  letter-spacing: 0;
  color: black;

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 32px;
    line-height: 36px;
  `}
`;

export const Date2 = styled.div`
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-size: ${pxToRem(20)};
  line-height: ${pxToRem(40)};
  letter-spacing: 0;
  color: black;

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 14px;
    line-height: 26px;
  `}
`;

export const Name1 = styled.div`
  font-size: ${pxToRem(20)};
  font-weight: 700;
  line-height: ${pxToRem(44)};
  letter-spacing: 0px;
  color: #979797;
  white-space: normal;     /* 🔥 줄바꿈 허용 */
  word-break: keep-all;    /* 🔥 단어 단위로 줄바꿈 (한국어에 좋음) */
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.tablet`
    font-size: 20px;
    line-height: 40px;
  `}

  ${media.mobile`
    font-size: 14px;
    line-height: 16px;
  `}
`;

export const Name2 = styled.div`
  font-size: ${pxToRem(20)};
  font-weight: 700;
  line-height: ${pxToRem(44)};
  letter-spacing: 0px;
  color: #979797;
  white-space: normal;     /* 🔥 줄바꿈 허용 */
  word-break: keep-all;    /* 🔥 단어 단위로 줄바꿈 (한국어에 좋음) */
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  white-space: normal;
  word-break: keep-all;

  ${media.mobile`
    font-size: 9px;
    line-height: 13px;
  `}
`;

export const KakaoBig = styled.div`
  font-family: 'KakaoBig OTF', sans-serif;
  font-weight: 800;     
  font-style: normal;   
  color: #464646;

  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.2px;
  vertical-align: middle;
`;